<template>
  <div v-if="options" class="modal__generic">
    <h3 v-if="options.header" class="modal__header">
      {{ options.header }}
    </h3>

    <p class="modal__text">
      {{ options.text }}
    </p>

    <div class="modal__actions">
      <oie-base-button
        v-for="button in options.buttons"
        :key="button.text"
        :css-classes="button.usePrimaryButton ? 'button--with-border button--blue' : 'button--true-ghost'"
        :text="button.text"
        @click="button.handler(button.handlerParams)"></oie-base-button>

      <oie-base-button
        css-classes="button--true-ghost"
        :text="tStatic('modalCancel')"
        @click.native="options.closeHandler ? options.closeHandler() : $modal.hide(options.name)"></oie-base-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss">
.modal__actions {
  display: flex;
  align-items: center;
}

.modal__actions > * + * {
  margin-left: measure(quarter);
}
</style>
